// Light/Dark theme provider with localStorage persistence and system fallback.
import React from "react";

const STORAGE_KEY = "spotcar:theme";

const ThemeContext = React.createContext({
    theme: "light",
    setTheme: () => {},
    toggle: () => {},
});

function getInitialTheme() {
    if (typeof window === "undefined") return "light";
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
    const sys = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
    return sys ? "dark" : "light";
}

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = React.useState(getInitialTheme);

    React.useEffect(() => {
        const root = document.documentElement;
        root.classList.toggle("dark", theme === "dark");
        root.style.colorScheme = theme;
        localStorage.setItem(STORAGE_KEY, theme);
    }, [theme]);

    const value = React.useMemo(
        () => ({
            theme,
            setTheme: setThemeState,
            toggle: () => setThemeState((t) => (t === "dark" ? "light" : "dark")),
        }),
        [theme],
    );

    return (
        <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    );
}

export function useTheme() {
    return React.useContext(ThemeContext);
}
